export default "__VITE_ASSET__c5772753__"